module.exports = __webpack_public_path__ + "img/photo-26.0176810a.webp";